export default {
  open_standalone: 'Avoinna',
  closed_standalone: 'Suljettu',

  open: 'Avoinna',
  closed: 'Suljettu',
  opening: 'Avaamme',
  closing: 'Suljemme',
  yes_we_are: 'Kyllä, olemme',
  sorry_we_are: 'Anteeksi, olemme',
  twentyfourseven: '24/7',
  closing_tomorrow: 'Suljemme huomenna',
  opening_tomorrow: 'Avaamme huomenna',
  at_x: 'kello %x%',
  closing_x: opts => `Suljemme %x%${opts.isWeekday ? 'na' : ''}`,
  opening_x: opts => `Avaamme %x%${opts.isWeekday ? 'na' : ''}`,

  monday: 'maanantai',
  tuesday: 'tiistai',
  wednesday: 'keskiviikko',
  thursday: 'torstai',
  friday: 'perjantai',
  saturday: 'lauantai',
  sunday: 'sunnuntai',

  businessHours: 'Aukioloajat',
  midnight: 'keskiyö'
};



// WEBPACK FOOTER //
// ./src/commons/translations/fin.js